import axios from "axios";

export const getVersionInfo = async() => {
    let versionInfo = JSON.parse(sessionStorage.getItem('appVer'));
    try {
        const {data} = await axios.get('/api/getVersion');
        sessionStorage.setItem('appVer', JSON.stringify(data));
        
        if (versionInfo && versionInfo.version!==data.version){
            window.location.reload(true);
        }else{
            setVersionHeartbeat();
        }
        
    } catch (error) {
        console.log("Error while fetching version", error);
        // ToDo: We can clear session store and call setVersionHeartbeat again. 
        // But it will be never ending if some serious error
    }
  }

  export const setVersionHeartbeat = () => {
    const versionInfo = JSON.parse(sessionStorage.getItem('appVer'));
    const defaultTimer = 30*60*1000;
    versionInfo ? setTimeout(getVersionInfo, versionInfo?.heartbeatMinutes*1000*60 || defaultTimer) : getVersionInfo();
}
        